import * as ss from 'superstruct';

export const OutputStreamWindowStats = ss.type({
  success: ss.number(),
  total: ss.number(),
});

export type OutputStreamWindowStats = ss.Infer<typeof OutputStreamWindowStats>;

export const OutputStreamStatsEntry = ss.type({
  outputStreamId: ss.number(),
  stats1d: OutputStreamWindowStats,
  stats7d: OutputStreamWindowStats,
  stats30d: OutputStreamWindowStats,
});

export type OutputStreamStatsEntry = ss.Infer<typeof OutputStreamStatsEntry>;

export const OutputStreamStatsResponse = ss.array(OutputStreamStatsEntry);

export type OutputStreamStatsResponse = ss.Infer<
  typeof OutputStreamStatsResponse
>;
